import { Interpolation, InterpolationFunction, StyledProps } from 'styled-components';
import { PostThemeElementsCornerStyle } from '../../types/PostThemeElementsTheme';

type CornerStyleMap = {
  [P in PostThemeElementsCornerStyle]?: Interpolation<StyledProps<unknown>>;
};

type InterPolationFactory = <P = unknown>(map: CornerStyleMap) => InterpolationFunction<StyledProps<P>>;

/**
 * Factory function for generating a styled-components interpolation function
 * based on a provided mapping of PostThemeElementsCornerStyle values.
 *
 * @param {CornerStyleMap} map - Mapping of
 * PostThemeElementsCornerStyle values to corresponding styled-components interpolations.
 *
 * @returns {InterPolationFactory} An interpolation
 * function that retrieves the appropriate interpolation based on the current theme's
 * PostThemeElements.Global.cornerStyle value.
 */
export const cornerStyleInterpolationFactory: InterPolationFactory = (map) => {
  return ({ theme }) => {
    return map[theme._postThemeElements.Global?.cornerStyle ?? 'rounded'];
  };
};
